module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp2_m.d1b0084285b105484893d5ebe29d6041.png";